export const editComponentModal = {
  extend: '/add-component-modal',
  props: {
    onInit: (el, s) => {
      const componentKey = s.key || el.call('getLastLocationPath').slice(1)
      const item = el.getItem(componentKey)
      return item && s.quietReplace(item)
    },
    onSubmit: async (e, el, s, ctx) => {
      e.preventDefault()

      const obj = s.parse()
      const { type, key } = obj
      delete obj.advanced

      if (!key) {
        el.call('openNotification', {
          title: el.call('polyglot', 'editor.addComponent.validation.title'),
          message: el.call('polyglot', 'editor.addComponent.keyRequired'),
          type: 'warning'
        })
        return
      }

      const res = el.call('updateItem', type, key, obj, { forceChosenUpdate: true })

      if (res?.success) {
        el.call('closeRouterModal')
      } else {
        el.call('openNotification', {
          title: el.call('polyglot', 'editor.addComponent.error.title'),
          message: el
            .call('polyglot', 'editor.addComponent.error.message')
            .replace('{type}', s.type)
            .replace('{title}', s.title),
          type: 'error'
        })
      }
    }
  },
  ModalHeader: {
    title: 'Edit {{ key }} component',
    p: 'Edit a platform schema for component'
  },
  Flex: {
    'Flex.info': {
      // The key is fixed once the component exists: the kit's disabled state
      // (the real attribute, the `field-disabled` pair, the not-allowed
      // cursor) — never an opacity dim (DESIGN_LANGUAGE §8.1), and no
      // `pointerEvents: 'none'`, which hid that cursor.
      'AppField.key': {
        AppInput: {
          disabled: true
        }
      }
    },
    'Button.showAdvanced': {},
    'Flex.advanced': {
      'GroupField.value': null
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      icon: 'checkmark',
      text: '{{ common.action.save | polyglot }}'
    },
    IconButton: {
      icon: 'trash outline',
      onClick: async (ev, el, s, ctx) => {
        if (s.key && window.confirm(`Do you want to remove the ${s.type}?`)) {
          el.sdk.deleteItem(`${s.type}s`, s.key)
          await el.call('closeRouterModal')
        }
      }
    }
  }
}
